export const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
export const LOGIN_TOKEN = "auth/LOGIN_TOKEN";
export const RESTORE_USER = "auth/RESTORE_USER";
export const UPDATE_AVATAR = "auth/UPDATE_AVATAR";
export const SET_REGISTER_INFO = "auth/SET_REGISTER_INFO";
export const CHANGE_LANGAUGE = "auth/CHANGE_LANGAUGE";
